export const defaultOperatorOptions = [
  { key: 'is', text: 'is', value: 'is' },
  { key: 'isAnyOf', text: 'is any of', value: 'is any of' },
];

export const timeOperatorOptions = [
  { key: 'isAfter', text: 'is after', value: 'is after' },
  { key: 'isBefore', text: 'is before', value: 'is before' },
];

export const userOperatorOptions = [
  { key: 'isAnyOf', text: 'is any of', value: 'is any of' },
];

export const zoneOperatorOptions = [
  { key: 'isAnyOf', text: 'is any of', value: 'is any of' },
];

export const getOperatorOptionsForColumn = (column) => {
  if (column === 'time') {
    return timeOperatorOptions;
  }
  if (column === 'user') {
    return userOperatorOptions;
  }

  if (column === 'zone') {
    return zoneOperatorOptions;
  }
  return defaultOperatorOptions;
};
